import React from 'react';
// import PropTypes from 'prop-types';
import Layout from '../../components/layout'
import Form from '../../components/Form'
import GetImage from '../../components/Image'
import '../../styles/pages/media-simulator.css'

const propTypes = {};

const defaultProps = {};

export default class mediaMarket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Layout>
         <div class="page-wrapper">
<div class="fullscreen bg13" data-scroll-index="0">
    <div class="grediant-overlay opacity-3"></div>
    <div class="center-col white-text" id="home">
          <div class="container">
              <div class="row">
                  <div class="col-md-10 col-lg-8" data-aos="fade-up" data-aos-duration="600" data-aos-delay="500">
                      <div class="home-content">
                          <h1 class="large-heading">
                              <span class="font-weight-extralight">Do you wish for effective marketing strategies?</span> <br/>
                          </h1>
                      </div>
                      <div class="section-header pt-50">
                            <h4>Optimize media spend up to 25% using media mix simulator</h4>
                        </div>
                  </div>
              </div>
          </div>
      </div>
      
</div>

<section class="pt-100 bg-light our-steps mt--40 media-1" data-scroll-index="1">
        <div class="container">
            <div class="section-header">
                <h2>What We Do</h2>
            </div>
            <div class="row">
                    <div class="col-md-4 mb-30 " data-aos="fade-left" data-aos-duration="400">
                            <div class="pricing-card-box-2 min-ht box-shadow">
                              <div class="pricing-header our-step" >
                                    <div class="step-number text-grediant lh-n font_12">Generate aggregate-level time series data</div>
                              </div>
                              <div class="pricing-body">
                                <ul class="list-unstyled">
                                <li>Channel-level marketing spend </li>
                                <li>Website visits</li>
                                <li>Competitor spend</li>
                                <li>Pricing</li>
                                <li>Sales volume</li>
                            </ul>
                              </div>
      
                            </div>
                          </div>

                          <div class="col-md-4 mb-30 " data-aos="fade-up" data-aos-duration="500">
                                <div class="pricing-card-box-2 min-ht box-shadow">
                                  <div class="pricing-header our-step" >
                                        <div class="step-number text-grediant lh-n font_12">Model wide variety of marketing situations</div>
                                  </div>
                                  <div class="pricing-body">
                                        <ul class="list-unstyled">
                                       <li>Different mixes of advertising spend</li>
                                       <li>Levels of ad effectiveness</li>
                                       <li>Types of ad targeting</li>
                                       <li>Sales seasonality</li>
                                       <li>Competitor activity and much more volume</li>
                                   </ul>
                                  </div>
          
                                </div>
                              </div>

                          <div class="col-md-4 mb-30 " data-aos="fade-right" data-aos-duration="600">
                                <div class="pricing-card-box-2 min-ht box-shadow">
                                  <div class="pricing-header our-step" >
                                        <div class="step-number text-grediant lh-n font_12">Improve measurement methods</div>
                                  </div>
                                  <div class="pricing-body">
                                        <ul class="list-unstyled">
                                            <li>Create ground truth for marketing performance metrics</li>
                                       <li>Have better Media Mix Models (MMMs), campaign optimization, and geo experiments</li>
                                       </ul>
                                  </div>
          
                                </div>
                              </div>
            </div>
        </div>
    </section>

<section class="pt-5 pb-5" data-scroll-index="1">
        <div class="container">
            <div class="section-header">
                <h2>How It Works</h2>
            </div>
            <div class="row">
                <div class="col-md-4 component-1"  data-aos="fade-up" data-aos-duration="400">
                    <div class="component-img">
                    <GetImage filename="compo-1.png" alt="consumer" />
                        <p>Consumer</p>
                    </div>
                    <div class="component-content">
                        <ul class="component-list-1">
                            <li>Category</li>
                            <li>Activity state</li>
                            <li>Satiation state</li>
                            <li>Market state</li>
                        </ul>
                        <ul class="component-list-2">
                                <li>Brand</li>
                                <li>Loyalty</li>
                                <li>Favorability</li>
                                <li>Availability</li>
                            </ul>
                    </div>
                </div>
                <div class="col-md-4 component-2"  data-aos="fade-up" data-aos-duration="500">
                        <div class="component-img">
                        <GetImage filename="compo-2.png" alt="media" />
                            <p>Media</p>
                        </div>
                        <div class="component-content">
                                <ul class="component-list-1">
                                <li>YouTube</li>
                                <li>Radio</li>
                                <li>Billboard</li>
                            </ul>
                            <ul class="component-list-2">
                                    <li>Paid search</li>
                                    <li>Television</li>
                                    <li>Newspaper</li>
                                </ul>
                        </div>
                    </div>
                    <div class="col-md-4 component-3"  data-aos="fade-up" data-aos-duration="600">
                            <div class="component-img">
                            <GetImage filename="compo-3.png" alt="other-data" />
                                <p>Other data</p>
                            </div>
                            <div class="component-content">
                                    <ul class="component-list">
                                    <li>Sales</li>
                                    <li>Seasonality</li>
                                    <li>Competition</li>
                                </ul>
                            </div>
                        </div>
                
            </div>
        </div>
</section>

<section class="pt-5 how-it-work" data-scroll-index="1">
        <div class="container">
            <div class="section-header">
                <h2>What You Get</h2>
            </div>
            <div class="row">
                <div class="col-md-3" data-aos="fade-up" data-aos-duration="300">
                        <div class="service-card border-img">
                          <div class="icon-img">
                            <i class="fa fa-database fa-2x"></i>
                          </div>
                          <div class="service-body">
                            <h6 class="service-title">Create Synthetic Data</h6>
                            <p class="service-description">A realistic ad system for the complex interplay between consumers, marketing tools, and environmental phenomena
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3" data-aos="fade-up" data-aos-duration="500">
                            <div class="service-card border-img">
                              <div class="icon-img">
                                <i class="fa fa-cubes fa-2x"></i>
                              </div>
                              <div class="service-body">
                                <h6 class="service-title"> Model </h6>
                                <p class="service-description">Response data (business KPIs) connected to media and marketing metrics along with control factors i.e. seasonality, weather and market competition
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3" data-aos="fade-up" data-aos-duration="700">
                                <div class="service-card border-img">
                                  <div class="icon-img">
                                    <i class="fa fa-crosshairs fa-2x"></i>
                                  </div>
                                  <div class="service-body">
                                    <h6 class="service-title">Analyze </h6>
                                    <p class="service-description">Quantification of the effectiveness and sales impact of all activities
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-3" data-aos="fade-up" data-aos-duration="900">
                                    <div class="service-card border-img">
                                      <div class="icon-img">
                                        <i class="fa fa-cog fa-2x"></i>
                                      </div>
                                      <div class="service-body">
                                        <h6 class="service-title">Optimize</h6>
                                        <p class="service-description">Simulations and optimizations to adjust marketing spends for improved results
                                        </p>
                                      </div>
                                    </div>
                                  </div>

        </div>
        </div>
    </section>

    <section id="products" class="pt-50 pb-50" data-scroll-index="1" data-aos="fade" data-aos-duration="400">
            <div class="container">
                <div class="section-header">
                    <h2>Application of Media Simulator for MMM</h2>
                </div>

                <div class="row">
                        <div class="col-md-4 pl-3 pr-3 product-section">
                                <div class="work-grid-box-1">
                                        <div class="grid-image grid-height-250">
                                        <GetImage filename="tv-meau.png"  alt="old-age"/>
                                        </div>
                                        <div class="image-box__overlay"></div>
                                        <div class="imgae-over-text pos-ali-old">
                                            <h5 class="grid-title white-text">Old Age MMM</h5>
                                        </div>
                                    </div>
                                    <div class="product-content imgae-over-tex list-1">
                                        <ul> 
                                        <li>MMM data collection can take anywhere between 1-2 months</li>
                                        <hr class="mb-0 mt-0" />
                                        <li>Often very expensive of impractical to run</li>
                                        <hr class="mb-0 mt-0" />
                                        <li>Team aggregate historical data based on availability, leading to loss of information</li>
                                        <hr class="mb-0 mt-0" />
                                        <li>Very high both in terms of time and resources</li>
                                    </ul>
                                    </div>
                                    
                        </div>
                        <div class="col-md-4 pl-3 pr-3 product-section">
                                <div class="work-grid-box-1">
                                        <div class="grid-image grid-height-250">
                                                <span class="right_arrow"></span>
                                                <span class="left_arrow"></span>
                                                <GetImage filename="tv-meau.png"  alt="vs"/>
                                        </div>
                                        <div class="image-box__overlay"></div>
                                        <div class="pos-center imgae-over-text">
                                            <h5 class="grid-title vs">VS</h5>
                                        </div>
                                    </div>
                                        <div class="product-content imgae-over-tex list-2">
                                            <ul>
                                                <li><h4>Time</h4></li>
                                                <hr class="mb-0 mt-0" />
                                                <li><h4>Validation</h4></li>
                                                <hr class="mb-0 mt-0" />
                                                <li><h4>Data</h4></li>
                                                <hr class="mb-0 mt-0" />
                                                <li> <h4>Cost </h4></li>
                                        </ul>
                                        </div>
                        </div>
                    <div class="col-md-4 pl-3 pr-3 product-section">
                            <div class="work-grid-box-1">
                                    <div class="grid-image grid-height-250">
                                    <GetImage filename="tv-meau.png"  alt="new-age"/>
                                    </div>
                                    <div class="image-box__overlay"></div>
                                    <div class="imgae-over-text pos-ali-new">
                                        <h5 class="grid-title white-text">New Age Simulator based MMM</h5>
                                    </div>
                                </div>
                                    <div class="product-content imgae-over-tex list-3">
                                        <ul>
                                        <li>Captures complex consumer purchase behaviour and response to marketing techniques</li>
                                        <hr class="mb-0 mt-0" />
                                        <li>Can replicate data features such as different levels of aggregation and hidden confounders</li>
                                        <hr class="mb-0 mt-0" />
                                        <li>Data can be generated with varying degrees of ad system complexity to better understand the capabilities and limitations of analytical models</li>
                                        <hr class="mb-0 mt-0" />
                                        <li>Possible to run virtual experiments, to provide ground truth for the evaluation of any measurement approach grounded in the analysis of aggregate data</li>
                                    </ul>
                                </div>
                </div>
                              </div>
                           </div>
        </section>




        <section class="contact-us-form theme-1 section-spacer" data-scroll-index="0">
            <div class="container">
                <div class="section-header">
                    <h2>Get in touch</h2>
                </div>
                <Form />
            </div>
        </section>
        </div>
      </Layout>
    );
  }
}

 mediaMarket.propTypes = propTypes;
 mediaMarket.defaultProps = defaultProps;